import { NgModule } from '@angular/core';
import { NgxFreshChatModule } from 'ngx-freshchat';
import { FreshChatDirective } from './fresh-chat.directive';

@NgModule({
    imports: [NgxFreshChatModule],
    declarations: [FreshChatDirective],
    exports: [FreshChatDirective]
})
export class FreshModule {}